/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-toggle-view-mode-2': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M2.5 16.25h15v1.25h-15v-1.25zm0-4.375h15v1.25h-15v-1.25zm5-8.125V7.5H3.75V3.75H7.5zm0-1.25H3.75c-.69 0-1.25.56-1.25 1.25V7.5c0 .69.56 1.25 1.25 1.25H7.5c.69 0 1.25-.56 1.25-1.25V3.75c0-.69-.56-1.25-1.25-1.25zm8.75 1.25V7.5H12.5V3.75h3.75zm0-1.25H12.5c-.69 0-1.25.56-1.25 1.25V7.5c0 .69.56 1.25 1.25 1.25h3.75c.69 0 1.25-.56 1.25-1.25V3.75c0-.69-.56-1.25-1.25-1.25z"/>'
  }
})
